module.exports = __webpack_public_path__ + "img/facebook.7cee424a.png";